import { Anchor, Container, Group, Stack, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { SelfImprovementList } from "../features/selfImprovement/SelfImprovementList";

// Страница «Предложения самообучения».
//
// Список improvement_proposal (pending сверху) с карточками и кнопками
// «Применить»/«Отклонить». Глобального меню в проекте нет — навигация
// ссылками; ссылка обратно на очередь рядом с заголовком.
export function SelfImprovementPage(): ReactElement {
  const { t } = useTranslation();

  return (
    <Container py="xl">
      <Stack gap="md">
        <Group justify="space-between">
          <Title order={1}>{t("selfImprovement.title")}</Title>
          <Group gap="md">
            <Anchor component={Link} to="/settings/agent-roles">
              {t("selfImprovement.agentRolesLink")}
            </Anchor>
            <Anchor component={Link} to="/queue">
              {t("selfImprovement.backToQueue")}
            </Anchor>
          </Group>
        </Group>

        <SelfImprovementList />
      </Stack>
    </Container>
  );
}
